import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";

export const OnboardingLandingVisaMobile = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const contacts = [
    { name: "Alejandro", image: "foto visa 1.png" },
    { name: "LingLing", image: "foto visa 2.png" },
    { name: "Pam", image: "foto visa 3.png" },
    { name: "Sean", image: "foto visa 4.png" },
  ];

  const handleButtonClickCardDetails = () => {
    const currentParams = location.search;
    navigate(`/vxlab-card_details-visa-mobile${currentParams}`);
  };

  const handleButtonRestart = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_register-visa-mobile${currentParams}`);
  };

  const styles = {
    telefono: {
      fontFamily: "Open Sans, sans-serif",
      marginTop: "30px",
      backgroundColor: "#f1f1f1",
      display: "flex",
      borderRadius: "50px",
      border: "15px solid #000000",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%",
    },
    arrow: {
      fontSize: "26px",
      marginLeft: "8px",
    },
    lines: {
      display: "flex",
      flexDirection: "column",
      marginRight: "8px",
    },
    lineBlue: {
      width: "30px",
      height: "6px",
      backgroundColor: colors.primario,
      marginBottom: "4px",
    },
    lineYellow: {
      width: "30px",
      height: "6px",
      backgroundColor: colors.secundario,
    },
    title: {
      fontWeight: "bold",
      fontSize: "14px",
    },
    page: {
      fontFamily: "Open Sans, sans-serif",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "30px",
      position: "relative",
      backgroundColor: "#ffffff",
      width: "375px",
      height: "812px",
      overflow: "hidden",
      boxShadow: "0 0 20px rgba(0,0,0,0.1)",
    },
    container: {
      display: "flex",
      flexDirection: "column",
      padding: "16px",
      height: "100%",
      boxSizing: "border-box",
      alignItems: "center",
      justifyContent:'flex-start',
      margin: "16px 0 8px 0",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "16px",
      width:'100%'
    },
    balance: {
      color: "#333",
      borderRadius: "12px",
      padding: "2px",
      textAlign: "center",
      marginBottom: "2px",
      display:'flex',

    },
    balanceCard: {
      display: "flex",
      color: "white",
      borderRadius: "12px 12px 0px 0px",
      padding: "12px",
      justifyContent: "space-between",
      textAlign: "center",
      height: "160px",
      marginBottom: "0px",
      width:'90%',
      flexDirection:'column',
    },
    balanceText: {
      fontSize: "20px",
      fontWeight: "bold",
    },
    actionButtons: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "16px",
    },
    actionButton: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      width: "190px",
      margin: "0 4px",
      padding: "12px",
      backgroundColor: "#f1f1f1",
      border: "none",
      fontWeight: "500",
      cursor: "pointer",
    },

    actionButton2: {
      marginTop: 9,
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      width: "190px",
      padding: "8px",
      backgroundColor: colors.secundario,
      border: "none",
      borderRadius: 50,
      fontWeight: "500",
      cursor: "pointer",
    },
    avatarRow: {
      marginTop: "10px",
      display: "flex",
      alignItems: "center",
      gap: "29px",
      marginBottom: "16px",
    },
    avatar: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      fontSize: "12px",
    },
    avatarImg: {
      width: "60px",
      height: "60px",
      border: `1px solid #f7f7f7`,
      objectFit: "cover",
    },
    promoCard: {
      display: "flex",
      alignItems: "center",

      borderRadius: "12px",
      padding: "12px",
    },
    promoImg: {
      width: "60px",
      height: "60px",
      marginRight: "12px",
    },
    bottomNav: {
      display: "flex",
      justifyContent: "space-around",
      borderTop: "1px solid #f7f7f7",
      paddingTop: "8px",
      marginTop: "auto",
      width:'100%',
    },
    navItem: {
      width: "70px",
      alignItems: "center",
      gap: 6,
      display: "flex",
      justifyContent: "space-between",
      fontSize: "14px",
      color: "#333",
    },
  };

  return (
      <div style={styles.telefono}>
        <div style={styles.page}>
          <div style={{ ...styles.container, width: "100%",backgroundColor:'#e7e7e7',paddingLeft:0, paddingRight:0 }}>

            <div style={{...styles.header, paddingLeft:2, paddingRight:2}}>

              {colors.url_logo !== "" ? (
                  <img className="inicio-de-sesion-de-2" src={colors.url_logo} style={{height: 50,maxWidth:100, objectFit:'contain'}}/>) : (<></>)}

              <div
                  style={{
                    display: "flex",
                    gap: 8,
                    justifyItems: "center",
                    placeItems: "center",
                  }}
              >
                <div>2,015 pts</div>
                <img
                    src="https://randomuser.me/api/portraits/men/75.jpg"
                    alt="User"
                    style={{ ...styles.avatarImg, borderRadius: 50 }}
                />
              </div>
            </div>

            <div style={{...styles.balanceCard,background: colors.url_card ? `url(${colors.url_card})` : "linear-gradient(90deg, #c49d14, #d6c37f)", borderTopRightRadius:20, borderTopLeftRadius:20}} onClick={handleButtonClickCardDetails}>

              <div style={{
                ...styles.container,
                flexDirection: "row",
                width: '100%',
                justifyContent: 'space-between',
                paddingTop: 0,
                paddingBottom:0,
              }}>

                <svg
                    width={63}
                    height={19}
                    viewBox="0 0 63 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M36.4625 15.0292C34.5008 15.0292 33.4252 14.7603 31.7734 14.0817L31.1614 13.8025L30.4674 17.836C31.6607 18.3277 33.8119 18.7502 36.0374 18.7835C41.2642 18.7835 44.6805 16.3583 44.7215 12.6271C44.7624 10.5757 43.4154 9.0187 40.5702 7.73568C38.8441 6.90338 37.7686 6.3451 37.7686 5.49999C37.7686 4.7522 38.6879 3.95575 40.6086 3.95575C42.2604 3.93014 43.4154 4.28099 44.3348 4.64464L44.7957 4.84951L45.4897 0.951782L45.3694 0.977392C44.3783 0.608619 42.8341 0.216797 40.9134 0.216797C35.9964 0.216797 32.5263 2.65992 32.5007 6.16071C32.47 8.73444 34.9695 10.1839 36.8569 11.047C38.7955 11.9305 39.4434 12.4862 39.4383 13.2801C39.4255 14.4863 37.8889 15.0292 36.4625 15.0292ZM58.1305 0.547156H54.2891C53.0931 0.547156 52.1994 0.867272 51.6744 2.04018L44.2861 18.5325H49.513L50.5578 15.8333L56.9345 15.8385C57.0907 16.4684 57.5491 18.5325 57.5491 18.5325H62.1562L58.1305 0.547156ZM51.9894 12.143L53.9715 7.11593C53.9459 7.16715 54.3813 6.0762 54.6322 5.40011L54.9728 6.95203L56.1227 12.143H51.9894Z"
                      fill="white"
                  />
                  <path
                      d="M22.3185 18.3891H27.297L30.4085 0.396084H25.4326V0.390963L22.3185 18.3891Z"
                      fill="white"
                  />
                  <path
                      d="M13.3015 12.8114L12.7842 10.312V10.3196L11.0377 2.05808C10.738 0.913345 9.86219 0.575301 8.77636 0.534326H0.758115L0.694092 0.913343C2.49954 1.3359 4.12573 1.94796 5.58033 2.69831C5.84154 2.85965 5.95166 3.03635 6.0413 3.29757L10.3436 18.5069H15.6038L23.4428 0.547131H18.1698L13.3015 12.8114Z"
                      fill="white"
                  />
                </svg>
                <div> ****9821</div>
              </div>

              <div style={{
                ...styles.container,
                flexDirection: "row",
                width: '100%',
                justifyContent: 'flex-start',
                paddingTop:0,
                paddingBottom:0,
                marginTop:1,
                marginBottom:1,
              }}>
                <div style={{...styles.balanceText,margin:0,padding:0}}>$ 6,256.49 USD</div>
              </div>

              <div style={{
                ...styles.container,
                flexDirection: "column",
                width: '100%',
                justifyContent: 'flex-start',
                alignItems:'flex-start',
                paddingTop: 0,
                paddingBottom: 0,
                marginTop:1,
                marginBottom:1,
              }}>
                <div style={{...styles.balanceText, margin: 0, padding: 0, fontSize: 12,fontWeight:'bold'}}>Card Holder</div>
                <div style={{...styles.balanceText, margin: 0, padding: 0, fontSize: 12}}>Jhon Doe</div>

              </div>
            </div>

            <div style={{backgroundColor:'#FFFFFF',height:'80%', width:'100%',borderTopLeftRadius:40, borderTopRightRadius:40,marginTop:-10}}>

              <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingTop: 40,
                paddingLeft: 10,
                paddingRight: 10
              }}>
                <div style={{
                  width: 70,
                  height: 70,
                  backgroundColor: '#f7f7f7',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <svg width="40" height="40" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1882_2410)">
                      <path
                          d="M20.2262 18.6695H20.2248C19.8367 18.6695 19.5224 18.9852 19.5231 19.374V20.2909C19.5231 23.7777 19.5231 23.8821 18.8917 24.8503C18.377 25.6392 17.2949 25.893 14.2588 25.9366H13.9487C13.9016 25.9366 13.8552 25.9352 13.8095 25.9345L15.2474 23.4103C16.0082 22.1552 15.6109 20.5134 14.3572 19.7463C13.1008 18.9771 11.4526 19.3737 10.6806 20.6351C10.0527 21.6792 9.32569 22.5019 8.79694 22.9055C8.68514 21.7748 8.68514 20.2455 8.68514 18.2909C8.68514 14.9201 8.68514 12.8852 9.23639 11.8657C9.68498 11.036 10.6222 10.7442 13.0937 10.6641C13.4819 10.6514 13.7863 10.3266 13.7737 9.93844C13.761 9.55805 13.4488 9.25781 13.0712 9.25781C13.0635 9.25781 13.0558 9.25781 13.048 9.25781C10.4071 9.34359 8.82084 9.67758 7.99959 11.1956C7.371 12.3579 7.29084 14.0637 7.2803 16.9451C6.81483 16.9008 6.18694 16.8811 5.49928 16.969C3.58608 17.213 2.12006 18.1643 1.26014 19.7196C-0.544079 22.9814 -1.67681 24.9649 -1.68806 24.9846C-1.88072 25.3214 -1.7633 25.751 -1.4265 25.9437C-1.31611 26.0063 -1.19658 26.0365 -1.07845 26.0365C-0.834469 26.0365 -0.596813 25.9092 -0.467438 25.6821C-0.456188 25.6624 0.680765 23.6712 2.49061 20.4002C3.12834 19.2478 4.18655 18.5644 5.63709 18.3696C6.28889 18.2817 6.88373 18.3148 7.27889 18.3598C7.27889 20.4558 7.2803 21.9886 7.41108 23.1776H6.30506C5.91694 23.1776 5.60194 23.4926 5.60194 23.8807C5.60194 24.2688 5.91694 24.5838 6.30506 24.5838H8.15991C8.1817 24.5859 8.2042 24.5873 8.2267 24.5873C8.25694 24.5873 8.28717 24.5845 8.31811 24.5803C9.06905 24.5459 9.88045 23.9925 10.7959 22.8872C11.4189 22.1341 11.8682 21.3909 11.8844 21.3642C12.2486 20.7694 13.0297 20.5816 13.6246 20.9459C14.2194 21.3101 14.4079 22.0912 14.043 22.6861L12.0876 26.118C12.0109 26.1989 11.9533 26.298 11.9223 26.4084L11.5314 27.0954L11.518 27.12C9.72366 30.5801 4.17037 32.0166 4.09655 32.0348C3.71967 32.1291 3.49116 32.5109 3.58537 32.8877C3.66553 33.207 3.9517 33.4207 4.2667 33.4207C4.32295 33.4207 4.38061 33.4137 4.43756 33.3996C4.69069 33.3363 10.663 31.8028 12.7597 27.7802L13.0206 27.3225C13.2969 27.3316 13.5993 27.3387 13.9361 27.3436H14.2708H14.2757C17.0369 27.3042 19.0689 27.158 20.0715 25.6195C20.9308 24.3012 20.9308 24.1672 20.9308 20.2923C20.9308 19.9737 20.9308 19.6679 20.9308 19.3733C20.9308 18.9852 20.6158 18.6716 20.2276 18.6716L20.2262 18.6695Z"
                          fill={colors.primario}/>
                      <path
                          d="M15.7747 17.3305H15.7761C16.1643 17.3305 16.4786 17.0148 16.4779 16.626V15.7091C16.4779 12.2223 16.4779 12.1179 17.1093 11.1497C17.624 10.3608 18.7061 10.107 21.7422 10.0634H22.0522C22.0994 10.0634 22.1458 10.0648 22.1915 10.0655L20.7536 12.5897C19.9928 13.8448 20.3901 15.4866 21.6437 16.2537C22.9002 17.0229 24.5483 16.6263 25.3204 15.3649C25.9483 14.3208 26.6753 13.4981 27.204 13.0945C27.3158 14.2252 27.3158 15.7545 27.3158 17.7091C27.3158 21.0799 27.3158 23.1148 26.7646 24.1343C26.316 24.964 25.3787 25.2558 22.9072 25.3359C22.5191 25.3486 22.2147 25.6734 22.2273 26.0616C22.24 26.442 22.5522 26.7422 22.9297 26.7422C22.9375 26.7422 22.9452 26.7422 22.9529 26.7422C25.5939 26.6564 27.1801 26.3224 28.0014 24.8044C28.63 23.6421 28.7101 21.9363 28.7207 19.0549C29.1861 19.0992 29.814 19.1189 30.5017 19.031C32.4149 18.787 33.8809 17.8357 34.7408 16.2804C36.5451 13.0186 37.6778 11.0351 37.689 11.0154C37.8817 10.6786 37.7643 10.249 37.4275 10.0563C37.3171 9.99375 37.1976 9.96352 37.0794 9.96352C36.8354 9.96352 36.5978 10.0908 36.4684 10.3179C36.4572 10.3376 35.3202 12.3288 33.5104 15.5998C32.8726 16.7522 31.8144 17.4356 30.3639 17.6304C29.7121 17.7183 29.1172 17.6852 28.7221 17.6402C28.7221 15.5442 28.7207 14.0114 28.5899 12.8224H29.6959C30.084 12.8224 30.399 12.5074 30.399 12.1193C30.399 11.7312 30.084 11.4162 29.6959 11.4162H27.8411C27.8193 11.4141 27.7968 11.4127 27.7743 11.4127C27.744 11.4127 27.7138 11.4155 27.6829 11.4197C26.9319 11.4541 26.1205 12.0075 25.2051 13.1128C24.5821 13.8659 24.1328 14.6091 24.1166 14.6358C23.7524 15.2306 22.9712 15.4184 22.3764 15.0541C21.7815 14.6899 21.5931 13.9088 21.958 13.3139L23.9134 9.88195C23.9901 9.80109 24.0477 9.70195 24.0786 9.59156L24.4696 8.90461L24.4829 8.88C26.2773 5.41992 31.8306 3.98344 31.9044 3.96516C32.2813 3.87094 32.5098 3.48914 32.4156 3.11227C32.3354 2.79305 32.0493 2.5793 31.7343 2.5793C31.678 2.5793 31.6204 2.58633 31.5634 2.60039C31.3103 2.66367 25.3379 4.19719 23.2412 8.21977L22.9804 8.6775C22.704 8.66836 22.4017 8.66133 22.0649 8.65641H21.7302H21.7253C18.9641 8.69578 16.9321 8.84203 15.9294 10.3805C15.0702 11.6988 15.0702 11.8328 15.0702 15.7077C15.0702 16.0263 15.0702 16.3321 15.0702 16.6267C15.0702 17.0148 15.3852 17.3284 15.7733 17.3284L15.7747 17.3305Z"
                          fill={colors.primario}/>
                    </g>
                    <defs>
                      <clipPath id="clip0_1882_2410">
                        <rect width="36" height="36" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                  <span style={{fontFamily: "Open Sans, sans-serif",fontSize:12,marginTop:1}}>Request</span>
                </div>

                <div style={{
                  width: 70,
                  height: 70,
                  backgroundColor: '#f7f7f7',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <svg width="40" height="40" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1882_2410_tap)">
                      <path d="M20.2262 18.6695H20.2248C19.8367 18.6695 19.5224 18.9852 19.5231 19.374V20.2909C19.5231 23.7777 19.5231 23.8821 18.8917 24.8503C18.377 25.6392 17.2949 25.893 14.2588 25.9366H13.9487C13.9016 25.9366 13.8552 25.9352 13.8095 25.9345L15.2474 23.4103C16.0082 22.1552 15.6109 20.5134 14.3572 19.7463C13.1008 18.9771 11.4526 19.3737 10.6806 20.6351C10.0527 21.6792 9.32569 22.5019 8.79694 22.9055C8.68514 21.7748 8.68514 20.2455 8.68514 18.2909C8.68514 14.9201 8.68514 12.8852 9.23639 11.8657C9.68498 11.036 10.6222 10.7442 13.0937 10.6641C13.4819 10.6514 13.7863 10.3266 13.7737 9.93844C13.761 9.55805 13.4488 9.25781 13.0712 9.25781C13.0635 9.25781 13.0558 9.25781 13.048 9.25781C10.4071 9.34359 8.82084 9.67758 7.99959 11.1956C7.371 12.3579 7.29084 14.0637 7.2803 16.9451C6.81483 16.9008 6.18694 16.8811 5.49928 16.969C3.58608 17.213 2.12006 18.1643 1.26014 19.7196C-0.544079 22.9814 -1.67681 24.9649 -1.68806 24.9846C-1.88072 25.3214 -1.7633 25.751 -1.4265 25.9437C-1.31611 26.0063 -1.19658 26.0365 -1.07845 26.0365C-0.834469 26.0365 -0.596813 25.9092 -0.467438 25.6821C-0.456188 25.6624 0.680765 23.6712 2.49061 20.4002C3.12834 19.2478 4.18655 18.5644 5.63709 18.3696C6.28889 18.2817 6.88373 18.3148 7.27889 18.3598C7.27889 20.4558 7.2803 21.9886 7.41108 23.1776H6.30506C5.91694 23.1776 5.60194 23.4926 5.60194 23.8807C5.60194 24.2688 5.91694 24.5838 6.30506 24.5838H8.15991C8.1817 24.5859 8.2042 24.5873 8.2267 24.5873C8.25694 24.5873 8.28717 24.5845 8.31811 24.5803C9.06905 24.5459 9.88045 23.9925 10.7959 22.8872C11.4189 22.1341 11.8682 21.3909 11.8844 21.3642C12.2486 20.7694 13.0297 20.5816 13.6246 20.9459C14.2194 21.3101 14.4079 22.0912 14.043 22.6861L12.0876 26.118C12.0109 26.1989 11.9533 26.298 11.9223 26.4084L11.5314 27.0954L11.518 27.12C9.72366 30.5801 4.17037 32.0166 4.09655 32.0348C3.71967 32.1291 3.49116 32.5109 3.58537 32.8877C3.66553 33.207 3.9517 33.4207 4.2667 33.4207C4.32295 33.4207 4.38061 33.4137 4.43756 33.3996C4.69069 33.3363 10.663 31.8028 12.7597 27.7802L13.0206 27.3225C13.2969 27.3316 13.5993 27.3387 13.9361 27.3436H14.2708H14.2757C17.0369 27.3042 19.0689 27.158 20.0715 25.6195C20.9308 24.3012 20.9308 24.1672 20.9308 20.2923C20.9308 19.9737 20.9308 19.6679 20.9308 19.3733C20.9308 18.9852 20.6158 18.6716 20.2276 18.6716L20.2262 18.6695Z" fill={colors.primario}/>
                      <path d="M15.7747 17.3305H15.7761C16.1643 17.3305 16.4786 17.0148 16.4779 16.626V15.7091C16.4779 12.2223 16.4779 12.1179 17.1093 11.1497C17.624 10.3608 18.7061 10.107 21.7422 10.0634H22.0522C22.0994 10.0634 22.1458 10.0648 22.1915 10.0655L20.7536 12.5897C19.9928 13.8448 20.3901 15.4866 21.6437 16.2537C22.9002 17.0229 24.5483 16.6263 25.3204 15.3649C25.9483 14.3208 26.6753 13.4981 27.204 13.0945C27.3158 14.2252 27.3158 15.7545 27.3158 17.7091C27.3158 21.0799 27.3158 23.1148 26.7646 24.1343C26.316 24.964 25.3787 25.2558 22.9072 25.3359C22.5191 25.3486 22.2147 25.6734 22.2273 26.0616C22.24 26.442 22.5522 26.7422 22.9297 26.7422C22.9375 26.7422 22.9452 26.7422 22.9529 26.7422C25.5939 26.6564 27.1801 26.3224 28.0014 24.8044C28.63 23.6421 28.7101 21.9363 28.7207 19.0549C29.1861 19.0992 29.814 19.1189 30.5017 19.031C32.4149 18.787 33.8809 17.8357 34.7408 16.2804C36.5451 13.0186 37.6778 11.0351 37.689 11.0154C37.8817 10.6786 37.7643 10.249 37.4275 10.0563C37.3171 9.99375 37.1976 9.96352 37.0794 9.96352C36.8354 9.96352 36.5978 10.0908 36.4684 10.3179C36.4572 10.3376 35.3202 12.3288 33.5104 15.5998C32.8726 16.7522 31.8144 17.4356 30.3639 17.6304C29.7121 17.7183 29.1172 17.6852 28.7221 17.6402C28.7221 15.5442 28.7207 14.0114 28.5899 12.8224H29.6959C30.084 12.8224 30.399 12.5074 30.399 12.1193C30.399 11.7312 30.084 11.4162 29.6959 11.4162H27.8411C27.8193 11.4141 27.7968 11.4127 27.7743 11.4127C27.744 11.4127 27.7138 11.4155 27.6829 11.4197C26.9319 11.4541 26.1205 12.0075 25.2051 13.1128C24.5821 13.8659 24.1328 14.6091 24.1166 14.6358C23.7524 15.2306 22.9712 15.4184 22.3764 15.0541C21.7815 14.6899 21.5931 13.9088 21.958 13.3139L23.9134 9.88195C23.9901 9.80109 24.0477 9.70195 24.0786 9.59156L24.4696 8.90461L24.4829 8.88C26.2773 5.41992 31.8306 3.98344 31.9044 3.96516C32.2813 3.87094 32.5098 3.48914 32.4156 3.11227C32.3354 2.79305 32.0493 2.5793 31.7343 2.5793C31.678 2.5793 31.6204 2.58633 31.5634 2.60039C31.3103 2.66367 25.3379 4.19719 23.2412 8.21977L22.9804 8.6775C22.704 8.66836 22.4017 8.66133 22.0649 8.65641H21.7302H21.7253C18.9641 8.69578 16.9321 8.84203 15.9294 10.3805C15.0702 11.6988 15.0702 11.8328 15.0702 15.7077C15.0702 16.0263 15.0702 16.3321 15.0702 16.6267C15.0702 17.0148 15.3852 17.3284 15.7733 17.3284L15.7747 17.3305Z" fill={colors.primario}/>
                    </g>
                    <defs>
                      <clipPath id="clip0_1882_2410_tap">
                        <rect width="36" height="36" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                  <span style={{fontFamily: "Open Sans, sans-serif",fontSize:12,marginTop:1}}>Tap & Pay</span>
                </div>

                <div style={{
                  width: 70,
                  height: 70,
                  backgroundColor: '#f7f7f7',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.0455 27.1818C10.0455 27.2159 10.0455 27.2159 10.0455 27.1818C10.0795 27.2159 10.1136 27.25 10.1477 27.2841C12.7727 29.6023 16.2159 31 20 31C23.7841 31 27.2273 29.6023 29.8523 27.2841C29.8864 27.25 29.9205 27.2159 29.9545 27.1818C33.0568 24.4545 35 20.4318 35 16C35 11.5682 33.0568 7.54545 29.9545 4.81818C29.9205 4.78409 29.8864 4.75 29.8523 4.71591C27.2273 2.39773 23.7841 1 20 1C16.2159 1 12.7727 2.39773 10.1477 4.71591C10.1136 4.75 10.0795 4.78409 10.0455 4.81818C6.94318 7.54545 5 11.5682 5 16C5 20.4318 6.94318 24.4545 10.0455 27.1818ZM12.2614 16.5114C12.2955 19.375 12.7386 22 13.4886 24.2159C12.3977 24.7273 11.375 25.4091 10.4545 26.1591C7.82955 23.7386 6.15909 20.3295 6.02273 16.5114H12.2614ZM14.7841 24.7614C16.2841 24.1818 17.8523 23.8409 19.4886 23.7727V29.9432C17.6136 29.6364 15.9432 27.6591 14.7841 24.7614ZM20.5114 29.9432V23.7727C22.1477 23.8409 23.7159 24.1818 25.2159 24.7614C24.0568 27.6591 22.3864 29.6364 20.5114 29.9432ZM20.5114 22.75V16.5114H26.7159C26.6818 19.1705 26.2386 21.6932 25.5227 23.8068C23.9545 23.1591 22.25 22.8182 20.5114 22.75ZM20.5114 15.4886V9.25C22.25 9.18182 23.9545 8.84091 25.5568 8.19318C26.2727 10.3068 26.6818 12.7955 26.75 15.4886H20.5114ZM20.5114 8.22727V2.05682C22.3864 2.36364 24.0568 4.34091 25.2159 7.23864C23.7159 7.81818 22.1477 8.15909 20.5114 8.22727ZM19.4886 2.05682V8.22727C17.8523 8.15909 16.2841 7.81818 14.7841 7.23864C15.9432 4.34091 17.6136 2.36364 19.4886 2.05682ZM19.4886 9.25V15.4886H13.2841C13.3182 12.8295 13.7614 10.3068 14.4773 8.19318C16.0455 8.84091 17.75 9.18182 19.4886 9.25ZM19.4886 16.5114V22.75C17.75 22.8182 16.0455 23.1591 14.4432 23.8068C13.7273 21.6932 13.3182 19.2045 13.25 16.5114H19.4886ZM11.2045 26.875C12.0227 26.2273 12.9091 25.6477 13.8295 25.2045C14.5795 27.0455 15.5341 28.5795 16.625 29.5682C14.6136 29.0568 12.7727 28.1364 11.2045 26.875ZM26.1705 25.2045C27.0909 25.6477 27.9773 26.2273 28.7955 26.875C27.2273 28.1364 25.3864 29.0909 23.375 29.5682C24.4659 28.5455 25.4205 27.0455 26.1705 25.2045ZM29.5455 26.1932C28.5909 25.4091 27.6023 24.7614 26.5114 24.25C27.2614 22.0341 27.7045 19.4091 27.7386 16.5455H33.9773C33.8409 20.3295 32.1705 23.7386 29.5455 26.1932ZM33.9773 15.4886H27.7386C27.7045 12.625 27.2614 10 26.5114 7.78409C27.6023 7.27273 28.625 6.59091 29.5455 5.84091C32.1705 8.26136 33.8409 11.6705 33.9773 15.4886ZM28.7955 5.125C27.9773 5.77273 27.0909 6.35227 26.1705 6.79545C25.4205 4.95455 24.4659 3.42045 23.375 2.43182C25.3864 2.94318 27.2273 3.86364 28.7955 5.125ZM13.8295 6.79545C12.9091 6.35227 12.0227 5.77273 11.2045 5.125C12.7727 3.86364 14.6136 2.90909 16.625 2.43182C15.5341 3.45455 14.5795 4.95455 13.8295 6.79545ZM10.4545 5.80682C11.4091 6.59091 12.3977 7.23864 13.4886 7.75C12.7386 9.96591 12.2955 12.5909 12.2614 15.4545H6.02273C6.15909 11.6705 7.82955 8.26136 10.4545 5.80682Z" fill={colors.primario}/>
                  </svg>
                  <span style={{fontFamily: "Open Sans, sans-serif",fontSize:12,marginTop:1}}>Transfer</span>
                </div>

                <div style={{
                  width: 70,
                  height: 70,
                  backgroundColor: '#f7f7f7',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <svg width="29" height="31" viewBox="0 0 29 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.50433 2.62485e-05C1.57283 2.62485e-05 0 1.5527 0 3.45952V15.501V30.4664C0.0001487 30.5523 0.0212557 30.6369 0.0615317 30.7131C0.101808 30.7892 0.160066 30.8547 0.231368 30.9038C0.30267 30.953 0.384914 30.9845 0.47113 30.9955C0.557345 31.0066 0.644991 30.997 0.726637 30.9674L5.7117 29.1646L10.6978 30.9674C10.8179 31.0109 10.9496 31.0109 11.0696 30.9674L16.0547 29.1646L21.0408 30.9674C21.1224 30.997 21.2101 31.0066 21.2963 30.9955C21.3825 30.9845 21.4648 30.953 21.5361 30.9038C21.6074 30.8547 21.6656 30.7892 21.7059 30.7131C21.7462 30.6369 21.7673 30.5523 21.7674 30.4664V11.6385H28.4614C28.6048 11.6379 28.7421 11.5811 28.8431 11.4805C28.9441 11.3799 29.0005 11.2437 29 11.1019V4.09944C29 1.86056 27.1769 0.0396945 24.9179 0.0010686C24.9134 0.000655109 24.9088 0.000298891 24.9043 0L3.50433 2.62485e-05ZM3.50433 1.06898H22.0452C21.2101 1.81885 20.6849 2.89932 20.6849 4.09944V11.1019V29.7012L16.2427 28.0915C16.1226 28.0481 15.9909 28.0481 15.8709 28.0915L10.8858 29.8985L5.8997 28.0915C5.77999 28.0483 5.6487 28.0483 5.52899 28.0915L1.08151 29.7012V8.13517V3.45952C1.08151 2.12766 2.152 1.06898 3.50433 1.06898ZM24.8451 1.06898C26.5586 1.06898 27.9185 2.41139 27.9185 4.09944V10.5696H21.7674V4.09944C21.7674 2.41139 23.1315 1.06898 24.8451 1.06898ZM5.10125 7.95353C5.03023 7.95325 4.95986 7.9668 4.89415 7.99341C4.82843 8.02002 4.76867 8.05916 4.71826 8.10859C4.66785 8.15803 4.62778 8.2168 4.60035 8.28154C4.57292 8.34628 4.55866 8.41573 4.55838 8.48592C4.5581 8.55646 4.57195 8.62636 4.59914 8.69158C4.62632 8.7568 4.6663 8.81606 4.71676 8.86594C4.76723 8.91582 4.82718 8.95533 4.89317 8.9822C4.95916 9.00907 5.02988 9.02276 5.10125 9.02248H16.6693C16.7404 9.02221 16.8106 9.00811 16.8761 8.981C16.9416 8.95389 17.0011 8.91429 17.0511 8.86446C17.1011 8.81464 17.1407 8.75556 17.1676 8.69061C17.1946 8.62566 17.2083 8.55611 17.208 8.48592C17.2074 8.34489 17.1505 8.20979 17.0496 8.11007C16.9487 8.01034 16.812 7.95407 16.6693 7.95353H5.10125ZM5.10125 13.5645C5.02988 13.5642 4.95916 13.5779 4.89317 13.6048C4.82718 13.6317 4.76723 13.6712 4.71676 13.7211C4.66629 13.7709 4.62632 13.8302 4.59913 13.8954C4.57195 13.9606 4.5581 14.0305 4.55838 14.1011C4.55866 14.1713 4.57292 14.2407 4.60035 14.3055C4.62778 14.3702 4.66785 14.429 4.71826 14.4784C4.76867 14.5278 4.82844 14.567 4.89415 14.5936C4.95986 14.6202 5.03024 14.6337 5.10125 14.6335H16.6693C16.812 14.6329 16.9487 14.5767 17.0496 14.4769C17.1505 14.3772 17.2074 14.2421 17.208 14.1011C17.2083 14.0309 17.1946 13.9613 17.1676 13.8964C17.1407 13.8314 17.1011 13.7724 17.0511 13.7225C17.0011 13.6727 16.9416 13.6331 16.8761 13.606C16.8106 13.5789 16.7404 13.5648 16.6693 13.5645H5.10125ZM5.10125 19.1745C5.02988 19.1742 4.95916 19.1879 4.89317 19.2147C4.82718 19.2416 4.76723 19.2811 4.71676 19.331C4.6663 19.3809 4.62632 19.4401 4.59914 19.5054C4.57195 19.5706 4.5581 19.6405 4.55838 19.711C4.55866 19.7812 4.57292 19.8507 4.60035 19.9154C4.62778 19.9801 4.66785 20.0389 4.71826 20.0883C4.76867 20.1378 4.82843 20.1769 4.89415 20.2035C4.95986 20.2301 5.03023 20.2437 5.10125 20.2434H16.6693C16.812 20.2429 16.9487 20.1866 17.0496 20.0869C17.1505 19.9871 17.2074 19.852 17.208 19.711C17.2083 19.6408 17.1946 19.5713 17.1676 19.5063C17.1407 19.4414 17.1011 19.3823 17.0511 19.3325C17.0011 19.2826 16.9416 19.243 16.8761 19.2159C16.8106 19.1888 16.7404 19.1747 16.6693 19.1745H5.10125Z" fill={colors.primario}/>
                  </svg>
                  <span style={{fontFamily: "Open Sans, sans-serif",fontSize:12,marginTop:1}}>Bills</span>
                </div>
              </div>


              <div
                  style={{display: 'flex', flexDirection: 'column', paddingTop: 30, paddingLeft: 10, paddingRight: 10}}>

                   <span style={{
                     fontFamily: "Open Sans, sans-serif",
                     fontWeight: 'bold',
                     color: '#595959',
                   }}>Your Movements</span>

                <div style={{marginTop: 20}}>

                  {[
                    {"icon":"fooding","name":"Dinner","date":"10/09/2025 12:07","amount":"$127.25 USD"},
                    {"icon":"travel","name":"American Airlines KYI299","date":"10/09/2025 12:07","amount":"$900.00 USD"},
                    {"icon":"shopping","name":"Gift","date":"10/09/2025 12:07","amount":"$385.12 USD"},
                    {"icon":"transport","name":"Taxi","date":"10/09/2025 12:07","amount":"$11.03 USD"},
                  ].map((element,i)=>{
                    return (

                        <div key={"row"+i} style={{display: 'flex', flexDirection: 'row', width: '100%', paddingTop: 10, paddingBottom: 10, height:100}}>



                          <div style={{
                            width: '20%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            height: '100%',
                          }}>
                            <img src={'./img/'+element.icon+'.png'} style={{height: '60%', width: '60%'}}
                                 alt={''}/>
                          </div>

                          <div style={{
                            width: '50%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            height: '100%',}}>
                    <span style={{
                      fontFamily: "Open Sans, sans-serif",
                      fontWeight: 'bold',
                      color: '#595959'
                    }}>{element.name}</span>
                            <span style={{
                              fontFamily: "Open Sans, sans-serif",
                              fontWeight: 'regular',
                              color: '#595959'
                            }}>{element.date}</span>
                          </div>
                          <div style={{width: '30%', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
           <span style={{
             fontFamily: "Open Sans, sans-serif",
             fontWeight: 'regular',
             color: '#595959'
           }}>{element.amount}</span>
                          </div>
                        </div>
                    );
                  })}
                </div>
              </div>
            </div>


            {/*
            <img
                src="/img/bannervisa.png"
                style={{ width: "100%", height: "auto", borderRadius: 8 }}
            />
            <div style={styles.promoCard}>
              <div>
                <div style={{ fontSize: 12, fontWeight: 600 }}>Tap to phone</div>
                <div style={{ fontSize: 14 }}>Charge easier than ever!</div>
                <button style={styles.actionButton2}>
                  Know more <span style={styles.arrow}>›</span>
                </button>
              </div>
            </div>
            */}

            <div style={styles.bottomNav}>
              <div style={styles.navItem} >
                <svg
                    width={23}
                    height={26}
                    viewBox="0 0 23 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M0.0860297 23.9238H21.5216V8.9281L11.4826 1.79596L1.3024 8.9281V19.973"
                      stroke={colors.primario}
                      strokeWidth={2.5}
                      strokeLinejoin="round"
                  />
                </svg>
                Home
              </div>
              <div style={styles.navItem}>
                {" "}
                <img src={'./img/visa_wallet.png'} style={{height: 30, width: 30}}
                     alt={''}/>{" "}
                NEx
              </div>
              <div style={styles.navItem} onClick={handleButtonRestart}>
                {" "}
                <img src={'./img/visa_more.png'} style={{height: 30, width: 30}}
                     alt={''}/>{" "}
                More
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
